<template>
  <!--**********************************
          Main wrapper start
      ***********************************-->
  <div id="main-wrapper">
    <!--********************************** -->

    <!--**********************************
    Content body start
***********************************-->

    <div class="content-body pt-md-3 pt-0">
      <div class="container-fluid">
        <div
          class="form-head mb-sm-3 mb-3 d-flex flex-wrap align-items-center pt-3"
        >
          <h2 class="font-w600 title mb-2 mr-auto">{{ lan.admin[0].admin_portal[0].Dashboard}} </h2>
        </div>
        <div class="row">
          <div class="col-xl-3 col-sm-6 m-t35">
            <div class="card card-coin">
              <div class="card-body text-center">
                <!-- <svg
                  class="mb-3 currency-icon"
                  width="80"
                  height="80"
                  viewbox="0 0 80 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="40" cy="40" r="40" fill="white"></circle>
                  <path
                    d="M40.725 0.00669178C18.6241 -0.393325 0.406678 17.1907 0.00666126 39.275C-0.393355 61.3592 17.1907 79.5933 39.2749 79.9933C61.3592 80.3933 79.5933 62.8093 79.9933 40.7084C80.3933 18.6241 62.8092 0.390041 40.725 0.00669178ZM39.4083 72.493C21.4909 72.1597 7.17362 57.3257 7.50697 39.4083C7.82365 21.4909 22.6576 7.17365 40.575 7.49033C58.5091 7.82368 72.8096 22.6576 72.493 40.575C72.1763 58.4924 57.3257 72.8097 39.4083 72.493Z"
                    fill="#00ADA3"
                  ></path>
                  <path
                    d="M40.5283 10.8305C24.4443 10.5471 11.1271 23.3976 10.8438 39.4816C10.5438 55.549 23.3943 68.8662 39.4783 69.1662C55.5623 69.4495 68.8795 56.599 69.1628 40.5317C69.4462 24.4477 56.6123 11.1305 40.5283 10.8305ZM40.0033 19.1441L49.272 35.6798L40.8133 30.973C40.3083 30.693 39.6966 30.693 39.1916 30.973L30.7329 35.6798L40.0033 19.1441ZM40.0033 60.8509L30.7329 44.3152L39.1916 49.022C39.4433 49.162 39.7233 49.232 40.0016 49.232C40.28 49.232 40.56 49.162 40.8117 49.022L49.2703 44.3152L40.0033 60.8509ZM40.0033 45.6569L29.8296 39.9967L40.0033 34.3364L50.1754 39.9967L40.0033 45.6569Z"
                    fill="#00ADA3"
                  ></path>
                </svg> -->
                <p class="mb-0 mb-3 fs-14">
                  <h6 class="text-success mr-1">{{ lan.admin[0].admin_portal[0].New_Leads}}</h6>
                </p>
                <h2 class="text-black mb-2 font-w600">
                  {{ dashboardData.new_leads }}
                </h2>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 m-t35">
            <div class="card card-coin">
              <div class="card-body text-center">
                <!-- <svg
                  class="mb-3 currency-icon"
                  width="80"
                  height="80"
                  viewbox="0 0 80 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="40" cy="40" r="40" fill="white"></circle>
                  <path
                    d="M40 0C17.9083 0 0 17.9083 0 40C0 62.0917 17.9083 80 40 80C62.0917 80 80 62.0917 80 40C80 17.9083 62.0917 0 40 0ZM40 72.5C22.0783 72.5 7.5 57.92 7.5 40C7.5 22.08 22.0783 7.5 40 7.5C57.9217 7.5 72.5 22.0783 72.5 40C72.5 57.9217 57.92 72.5 40 72.5Z"
                    fill="#FFAB2D"
                  ></path>
                  <path
                    d="M42.065 41.2983H36.8133V49.1H42.065C43.125 49.1 44.1083 48.67 44.7983 47.9483C45.52 47.2566 45.95 46.275 45.95 45.1833C45.9517 43.0483 44.2 41.2983 42.065 41.2983Z"
                    fill="#FFAB2D"
                  ></path>
                  <path
                    d="M40 10.8333C23.9167 10.8333 10.8333 23.9166 10.8333 40C10.8333 56.0833 23.9167 69.1666 40 69.1666C56.0833 69.1666 69.1667 56.0816 69.1667 40C69.1667 23.9183 56.0817 10.8333 40 10.8333ZM45.935 53.5066H42.495V58.9133H38.8867V53.5066H36.905V58.9133H33.28V53.5066H26.9067V50.1133H30.4233V29.7799H26.9067V26.3866H33.28V21.0883H36.905V26.3866H38.8867V21.0883H42.495V26.3866H45.6283C47.3783 26.3866 48.9917 27.1083 50.1433 28.26C51.295 29.4116 52.0167 31.025 52.0167 32.775C52.0167 36.2 49.3133 38.995 45.935 39.1483C49.8967 39.1483 53.0917 42.3733 53.0917 46.335C53.0917 50.2816 49.8983 53.5066 45.935 53.5066Z"
                    fill="#FFAB2D"
                  ></path>
                  <path
                    d="M44.385 36.5066C45.015 35.8766 45.3983 35.0316 45.3983 34.08C45.3983 32.1916 43.8633 30.655 41.9733 30.655H36.8133V37.52H41.9733C42.91 37.52 43.77 37.12 44.385 36.5066Z"
                    fill="#FFAB2D"
                  ></path>
                </svg> -->
                <p class="mb-0 mb-3 fs-13">
                  <h6 class="text-danger mr-1">{{ lan.admin[0].admin_portal[0].Open_opportunities}}</h6>
                </p>
                <h2 class="text-black mb-2 font-w600">
                  {{ dashboardData.open_opportunities }}
                </h2>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 m-t35">
            <div class="card card-coin">
              <div class="card-body text-center">
                <!-- <svg
                  class="mb-3 currency-icon"
                  width="80"
                  height="80"
                  viewbox="0 0 80 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="40" cy="40" r="40" fill="white"></circle>
                  <path
                    d="M40.725 0.00669178C18.6241 -0.393325 0.406678 17.1907 0.00666126 39.275C-0.393355 61.3592 17.1907 79.5933 39.2749 79.9933C61.3592 80.3933 79.5933 62.8093 79.9933 40.7084C80.3933 18.6241 62.8092 0.390041 40.725 0.00669178ZM39.4083 72.493C21.4909 72.1597 7.17362 57.3257 7.50697 39.4083C7.82365 21.4909 22.6576 7.17365 40.575 7.49033C58.5091 7.82368 72.8096 22.6576 72.493 40.575C72.1763 58.4924 57.3257 72.8097 39.4083 72.493Z"
                    fill="#374C98"
                  ></path>
                  <path
                    d="M40.5283 10.8305C24.4443 10.5471 11.1271 23.3976 10.8438 39.4816C10.5438 55.549 23.3943 68.8662 39.4783 69.1662C55.5623 69.4495 68.8795 56.599 69.1628 40.5317C69.4462 24.4477 56.6123 11.1305 40.5283 10.8305ZM52.5455 56.9324H26.0111L29.2612 38.9483L25.4944 39.7317V36.6649L29.8279 35.7482L32.6447 20.2809H43.2284L40.8283 33.4481L44.5285 32.6647V35.7315L40.2616 36.6149L37.7949 50.2154H54.5122L52.5455 56.9324Z"
                    fill="#374C98"
                  ></path>
                </svg> -->
                <p class="mb-0 mb-3 fs-14">
                  <h6 class="text-success mr-1">{{ lan.admin[0].admin_portal[0].Won_opportunities}}</h6>
                </p>
                <h2 class="text-black mb-2 font-w600">
                  {{ dashboardData.won_opportunities }}
                </h2>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 m-t35">
            <div class="card card-coin">
              <div class="card-body text-center">
                <!-- <svg
                  class="mb-3 currency-icon"
                  width="80"
                  height="80"
                  viewbox="0 0 80 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="40" cy="40" r="40" fill="white"></circle>
                  <path
                    d="M40.725 0.00669178C18.6241 -0.393325 0.406708 17.1907 0.00669178 39.275C-0.393325 61.3592 17.1907 79.5933 39.275 79.9933C61.3592 80.3933 79.5933 62.8093 79.9933 40.7084C80.3933 18.6241 62.8093 0.390041 40.725 0.00669178ZM39.4083 72.493C21.4909 72.1597 7.17365 57.3257 7.507 39.4083C7.82368 21.4909 22.6576 7.17365 40.575 7.49033C58.5091 7.82368 72.8097 22.6576 72.493 40.575C72.1763 58.4924 57.3257 72.8097 39.4083 72.493Z"
                    fill="#FF782C"
                  ></path>
                  <path
                    d="M40.525 10.8238C24.441 10.5405 11.1238 23.391 10.8405 39.475C10.7455 44.5352 11.9605 49.3204 14.1639 53.5139H23.3326V24.8027C23.3326 23.0476 25.7177 22.4893 26.4928 24.0643L40 51.4171L53.5072 24.066C54.2822 22.4893 56.6674 23.0476 56.6674 24.8027V53.5139H65.8077C67.8578 49.6171 69.0779 45.2169 69.1595 40.525C69.4429 24.441 56.609 11.1238 40.525 10.8238Z"
                    fill="#FF782C"
                  ></path>
                  <path
                    d="M53.3339 55.1806V31.943L41.4934 55.919C40.9334 57.0574 39.065 57.0574 38.5049 55.919L26.6661 31.943V55.1806C26.6661 56.1007 25.9211 56.8474 24.9994 56.8474H16.2474C21.4326 64.1327 29.8629 68.9795 39.475 69.1595C49.4704 69.3362 58.3908 64.436 63.786 56.8474H55.0006C54.0789 56.8474 53.3339 56.1007 53.3339 55.1806Z"
                    fill="#FF782C"
                  ></path>
                </svg> -->
                <p class="mb-0 mb-3 fs-14">
                  <h6 class="text-danger mr-1">{{ lan.admin[0].admin_portal[0].Commission}}</h6>
                </p>
                <h2 class="text-black mb-2 font-w600">
                  ${{ dashboardData.commission }}
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-12">
            <div class="card">
              <div
                class="card-header pb-2 d-flex justify-content-between border-0"
              >
                <h4 class="fs-20 text-black mb-3">{{ lan.admin[0].admin_portal[0].Opportunity}}</h4>
                <router-link to="/add-selfopportunity"
                  ><button class="filter-btn up-btn m-0">
                    {{ lan.admin[0].admin_portal[0].New_opportunity}}
                  </button></router-link
                >
              </div>
              <!-- <div
                  class="card-header pb-2 d-block d-sm-flex flex-wrap border-0 justify-content-end"
                >
                  <div class="button justify-content-end d-flex">
                    <input
                      type="search"
                      name="search"
                      class="init new-init ml-3 w-new"
                      placeholder="Search"
                      v-model="search"
                    />
                    <div class="drop-down">
                      <button
                        class="filter-btn mb-0 dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                      {{ lan.admin[3].Opportunity[0].Filter_view }}
                      </button>
                      <div
                        class="dropdown-menu mt-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a class="dropdown-item" href="#">
                          <input
                            type="checkbox"
                            class="mr-3 sameInput"
                            id="open"
                            value="Open"
                            v-model="filterOptions.open"
                          />
                          <label for="open"> {{ lan.admin[3].Opportunity[0].Open }}</label><br />
                        </a>
                        <a class="dropdown-item" href="#">
                          <input
                            type="checkbox"
                            class="mr-3 sameInput"
                            id="won"
                            value="Won"
                            v-model="filterOptions.won"
                          />
                          <label for="won"> Won</label><br />
                        </a>
                        <a class="dropdown-item" href="#">
                            <input
                              type="checkbox"
                              class="mr-3 sameInput"
                              id="closed"
                              value="Lost"
                              v-model="filterOptions.lost"
                            />
                            <label for="closed"> {{ lan.admin[3].Opportunity[0].Closed }}</label><br />
                        </a>
                      </div>
                    </div>
                  </div>
              </div> -->
              <div class="card-body tab-content">
                <div class="tab-pane active show fade" id="monthly">
                  <div class="table-responsive">
                    <table
                      class="text-center bg-info-hover tr-rounded order-tbl"
                    >
                      <thead>
                        <tr>
                          <th></th>
                          <th>{{ lan.admin[0].admin_portal[0].Account}}</th>
                          <th>{{ lan.admin[0].admin_portal[0].Notes}}</th>
                          <th>{{ lan.admin[0].admin_portal[0].Date}}</th>
                          <th>{{ lan.admin[0].admin_portal[0].Contact}}</th>
                          <th>{{ lan.admin[0].admin_portal[0].Phone}}</th>
                          <th>{{ lan.admin[0].admin_portal[0].Quotes}}</th>
                          <th>{{ lan.admin[0].admin_portal[0].Status}}</th>
                        </tr>
                      </thead>
                      <tbody
                        v-if="
                          All_Opportunity_Details && All_Opportunity_Details.length
                        "
                      >
                        <tr
                          v-for="data in displayed_opportunity"
                          :key="data.opportunity_id"
                          @click="edit3(data.opportunity_id)"
                          class="pointer"
                          :style="data.status == 'Won' ? `background-color: #ECFAE4` : data.status == 'Lost' ? `background-color: #FFEFEE` : ''"
                        >
                        <td  v-if="data.seen == 0 ? true : false"><i class="fa-solid fa-eye"></i></td>
                        <td  v-if="data.seen == 1 ? true : false"><i class="fa-sharp fa-solid fa-eye-slash"></i></td>
                          <td>{{ data.account_detail.name }}</td>
                          <!-- <td>balaji</td> -->
                          <td v-if="data.note && data.note.length">
                            <span
                              v-for="(note, index) in JSON.parse(data.note)"
                              :key="index"
                              >{{ note.subject }},</span
                            >
                          </td>
                          <td v-else>0</td>
                          <td>{{ data.date }}</td>
                          <td v-if="data.contact_detail != null">
                            {{ data.contact_detail.first_name }}
                            {{ data.contact_detail.last_name }}
                          </td>
                          <td v-else></td>
                          <!-- <td>89456132164</td> -->
                          <td>{{ data.contact_detail.phone }}</td>
                          <td>
                            {{ data.submitted_quotes_count }} /
                            {{ data.total_quotes_count }}
                          </td>
                          <td>
                              <span
                                class="badge light badge"
                                :class="
                                  data.status == 'Open'
                                    ? 'badge-info' :
                                    data.status == 'New' ?
                                    'badge-success' : data.status == 'Lost' ? 'badge-danger' :'badge-success'
                                "
                                >{{ data.status }}</span
                              >
                            </td>
                        </tr>
                      </tbody>
                      <div class="lds-ellipsis" v-show="value3">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </table>
                    <div v-if="oppo_filtered.length > 5" class="text-right">
                <router-link to="/opportunity">
                  <button class="view-all-less-btn">{{ lan.Status.Show_more }}</button>
                </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-12 col-xxl-12">
            <div class="row">
              <div class="col-sm-12">
                <div class="card">
                  <div class="card-header border-0 pb-0">
                    <h4 class="mb-0 fs-20 text-black">{{ lan.admin[0].admin_portal[0].New_Leads}}</h4>
                  </div>
                  <div class="card-body pb-0">
                    <div class="table-responsive">
                      <table
                        class="text-center bg-info-hover tr-rounded order-tbl"
                      >
                        <thead>
                          <tr>
                            <th>{{ lan.admin[0].admin_portal[0].Company}}</th>
                            <th>{{ lan.admin[0].admin_portal[0].Contacts}}</th>
                            <th>{{ lan.admin[0].admin_portal[0].Participants}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(data, index) in leadsDetails"
                            :key="index"
                            @click="edit(data.lead_id)"
                            class="pointer"
                          >
                            <td>{{ data.company }}</td>
                            <td>{{ data.first_name }} {{ data.last_name }}</td>
                            <td>{{ data.date_of_conference }}</td>
                          </tr>
                          <div class="lds-ellipsis" v-show="value">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 mar-bo">
                <div class="card">
                  <div class="card-header border-0 pb-0">
                    <h4 class="mb-0 text-black fs-20">{{ lan.admin[0].admin_portal[0].My_tasks}}</h4>
                    <router-link to="/add-task"
                      ><button class="filter-btn up-btn m-0">
                        {{ lan.admin[0].admin_portal[0].New_task}}
                      </button></router-link
                    >
                  </div>
                  <div class="card-body pb-0">
                    <div class="table-responsive">
                      <table class="text-center tr-rounded order-tbl">
                        <thead>
                          <tr>
                            <th> {{ lan.admin[0].admin_portal[0].Subject}}</th>
                            <th>{{ lan.admin[0].admin_portal[0].Date}}</th>
                            <th>{{ lan.admin[0].admin_portal[0].Prio}}</th>
                            <th>{{ lan.admin[0].admin_portal[0].Status}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(data, index) in tasksDetails"
                            :key="index"
                            @click="edit1(data.task_id)"
                            class="pointer text-left"
                          >
                            <td>{{ data.subject }}</td>
                            <td>{{ data.due_date }}</td>
                            <td>
                              {{
                                data.priority == 1
                                  ? "High"
                                  : data.priority == 2
                                  ? "Medium"
                                  : "Low"
                              }}
                            </td>
                            <td>
                              <span
                                class="badge light"
                                :class="
                                  data.status == '1'
                                    ? 'badge-info'
                                    : 'badge-success'
                                "
                                >{{
                                  data.status == "1" ? "Open" : "Completed"
                                }}</span
                              >
                            </td>
                          </tr>
                          <div class="lds-ellipsis" v-show="value2">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-xxl-12">
            <div class="row"></div>
          </div>
        </div>
      </div>
    </div>
    <!--**********************************
    Content body end
***********************************-->
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from 'vuex'

export default {
  name: "Dashboard",
  data() {
    return {
      dashboardData: "",
      leadsDetails: "",
      tasksDetails: "",
      opportunitiesDetails: "",
      showAll_opportunity: false,
      value: true,
      value2: true,
      value3: true,
      search: "",
      filterOptions: {
        open: false,
        won: false,
        lost: false
      },
      // value4: true,
    };
  },
  // created() {
  //   this.$store.dispatch("tryAutoLogin");
  //   if (!this.$store.getters.isAdmin) { 
  //       alert("You can't access Admin Portal. If you are Admin first logout then Login Admin portal.")
  //     this.$router.back()
  //   }
  // },
  computed:{
    lan(){
      return this.$store.getters.whichLanguage
    },
    ...mapState({
      All_Opportunity_Details: (state) => state.editOpportunity.all_Opportunity_Details,
      totalAPICalls: (state) => state.apiProgress.totalAPICalls,
    }),

    oppo_filtered() {
      // var self = this;
      let filteredData = this.All_Opportunity_Details;
      // Apply filter based on status
      if (this.filterOptions.open || this.filterOptions.won || this.filterOptions.lost) {
        filteredData = filteredData.filter(opportunity => {
          if (this.filterOptions.open && opportunity.status === 'Open') return true;
          if (this.filterOptions.won && opportunity.status === 'Won') return true;
          if (this.filterOptions.lost && opportunity.status === 'Lost') return true;
          return false;
        });
      }
      // Apply search filter
      if (this.search.trim() !== '') {
        const searchTerm = this.search.toLowerCase();
        filteredData = filteredData.filter(opportunity => 
            (opportunity.account_detail && opportunity.account_detail.name && opportunity.account_detail.name.toLowerCase().includes(searchTerm)) ||
            (opportunity.contact_detail && opportunity.contact_detail.phone && opportunity.contact_detail.phone.toLowerCase().includes(searchTerm)) ||
            (opportunity.contact_detail && opportunity.contact_detail.first_name && opportunity.contact_detail.first_name.toLowerCase().includes(searchTerm)) ||
            (opportunity.contact_detail && opportunity.contact_detail.last_name && opportunity.contact_detail.last_name.toLowerCase().includes(searchTerm)) ||
            (opportunity.status && opportunity.status.toLowerCase().includes(searchTerm))
        );
      }
      return filteredData;
    },
    displayed_opportunity() {
      return this.showAll_opportunity ? this.oppo_filtered : this.oppo_filtered.slice(0, 5);
    },
  },
  created(){
    this.$store.dispatch("Get_Opportunites").then((res) => {
      console.log('then geting', res);
    })

    // this.$store.dispatch("Get_Opportunites")
  },

  mounted() {
    // *********GET Dashboard Data***********

    console.log('latest update');
    

    axios
      .get(axios.defaults.baseURL + "get-dashboard-data", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        this.dashboardData = res.data.data;
        // this.value4 = false;
      })
      .catch((err) => {
        // this.value4 = false;
        this.$store.dispatch("checkErrorAndSendToast", [
          err.response,
          "error",
        ]);
      });

    // *********GET LEADS***********
    axios
      .get(axios.defaults.baseURL + "leads", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        this.leadsDetails = res.data.data;
        this.value = false;
      })
      .catch((err) => {
        this.value = false;
        // if (err.response.statusText == "Unauthorized") {
        //   this.$router.push("/login").then(() => {
        //     this.$router.go();
        //   });
        // }
      });

    // *********GET TASKS***********
    axios
      .get(axios.defaults.baseURL + "tasks", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        this.tasksDetails = res.data.data;
        this.value2 = false;
      })
      .catch((err) => {
        this.value2 = false;
        // if (err.response.statusText == "Unauthorized") {
        //   this.$router.push("/login").then(() => {
        //     this.$router.go();
        //   });
        // }
      });

    // *********GET Opportunities***********
    axios
      .get(axios.defaults.baseURL + "opportunities", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        this.opportunitiesDetails = res.data.data;
        this.value3 = false;
      })
      .catch((err) => {
        this.value3 = false;
        // if (err.response.statusText == "Unauthorized") {
        //   this.$router.push("/login").then(() => {
        //     this.$router.go();
        //   });
        // }
      });
  },
  methods: {
    toggleViewAll_opportunity() {
      this.showAll_opportunity = !this.showAll_opportunity;
    },
    edit(id) {
      localStorage.setItem("editID", id);
      this.$router.push("/convert-lead-id=" + id);
    },
    edit1(id) {
      localStorage.setItem("editID", id);
      this.$router.push({ name: "Edit Task", params: { id: id } });
    },
    edit3(id) {
      // alert(localStorage.getItem("token"))
      axios
      .post(axios.defaults.baseURL + "eye-open/" + id ,  {
        
      }, {headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        }})
      .then((res) => {
        console.log("eye-open resp", res);
      })
      .catch((err) => {
        console.log("eye-open err", err);
      });
      
      localStorage.setItem("editID", id);
      this.$router.push({ name: "Edit Opportunity", params: { id: id } });
    },
    AddToast(message, title, type) {
      this.$store.commit("addToast", {
        title: title,
        type: type,
        message: message,
      });
      setTimeout(() => {
        this.dismissToast(title);
      }, 5000);
    },
    dismissToast(title) {
      this.$store.commit("clearToast", title);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
